module.exports = __webpack_public_path__ + "4dd8a234378a8ac461dabf6bbe3c7e11.fbx";